import {
  ConfigService,
  ErrorsService,
  ModelsList,
  StoreService,
  TransportInterventionDashboardMetrics,
  TransportInterventionPoi
} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {TransportIntervention} from 'shared';
import {map} from 'rxjs/operators';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class TransportInterventionService extends StoreService<TransportIntervention> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(TransportIntervention);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<TransportIntervention>> {
    return this.http.get<ModelsList<TransportIntervention>>(this.config.apiVerUrl('/app/transport-interventions'), {params: queryParams});
  }

  protected insert(values: TransportIntervention): Observable<number> {
    return null;
  }

  protected remove(id): Observable<void> {
    return null;
  }

  protected update(id, values: TransportIntervention): Observable<TransportIntervention> {
    return null;
  }

  poiList(id: number): Observable<ModelsList<TransportInterventionPoi>> {
    return this.http.get<ModelsList<TransportInterventionPoi>>(this.config.apiVerUrl(`/app/transport-interventions/${id}/poi-list`)).pipe(
      map(l => {
        l.data = (l.data as TransportInterventionPoi[]).map(m => new TransportInterventionPoi(m));
        return l;
      }),
    );
  }

  dashboard(from, to: Date): Observable<any> {
    return this.http.post<any>(this.config.apiVerUrl(`/app/transport-interventions/dashboard`), {from, to}).pipe(
      map(l => {
        l.metrics = (l.metrics as TransportInterventionDashboardMetrics[]).map(m => new TransportInterventionDashboardMetrics(m));
        return l;
      }),
    );
  }

}
